import React,{useState,useEffect,useRef} from 'react';

import { getFirestore,  collection,  addDoc,serverTimestamp,doc,updateDoc,setDoc, Timestamp } from "firebase/firestore";
import { TextField, Button,Dialog,DialogActions,DialogContent,DialogTitle } from '@mui/material';
import { app } from '../BD/Config';
import { ref, uploadBytesResumable, getDownloadURL,getStorage,uploadString } from "firebase/storage";
import { nanoid } from 'nanoid' ;
import { readAndCompressImage } from 'browser-image-resizer';

import '../StyleBase/imglogo.css'

export default function UploadImg({DocID, NoImg,detalle}) {
  console.log(detalle);
    const st={
        hd:{ visibility:"hidden" },
        sh:{ visibility:"visible"},
        inact:{"background-color":"#B03A2E" }
      }
    const [MdShowtakepicture,setMdShowtakepicture]=useState(false);
    const storage = getStorage (app);/*Conectar al server */
const [Urlmin,setUrlMin]=useState(detalle?.UrlMin);
const [imgUrl, setImgUrl] = useState(null);
const [progresspercent, setProgresspercent] = useState(0);
const [open, setOpen] = useState(false);
const[TkPicturemin,setTkPicturemin]=useState(null);
const [ProgrLoading,setProgrLoading]=useState(false);
const db = getFirestore(app);/*Conectar al server */
const [ImgUp,setImgUp]=useState();
const ImgFullHD = {quality: 0.8,maxWidth:280,maxHeight:280,autoRotate:true,debug: true,};
const ImgMinQuality = {quality: 0.8,maxWidth:60,maxHeight:60,autoRotate:true,debug: true,};
const changeHandler = async (e) => {
  if (e.target.files.length > 0) {
    // Comprime la imagen antes de subirla
    const compressedFileMax = await readAndCompressImage(e.target.files[0], ImgFullHD);

    setMdShowtakepicture(true);
    setProgrLoading(true);
    setImgUp(compressedFileMax); // Guarda la imagen comprimida
    setProgresspercent(0);

    setImgUrl(URL.createObjectURL(compressedFileMax));
    const compressedFile = await readAndCompressImage(compressedFileMax, ImgMinQuality);

    const reader = new FileReader();
    reader.onloadend = () => {
        let base64Image = reader.result;
        // Ahora puedes hacer algo con la imagen en base64
        setTkPicturemin(base64Image);
    };

    reader.readAsDataURL(compressedFile);
    hideLoading();
  }
};


       const handleSubmit = () => {
       // e.preventDefault()
     let namefile=nanoid();
     let namefilemin=nanoid();
     // const file = ImgUp;
      if (!ImgUp){ alert("Seleccionar imagen");return};

      console.log("imagen reducido");
     // console.log(TkPicturemin);
      const storageRef = ref(storage, `/Logo/${namefile}`);
      const storageRefmin = ref(storage, `/LogoMin/${namefilemin}`);
      const uploadTask = uploadBytesResumable(storageRef, ImgUp);
  
      uploadTask.on("state_changed",
        (snapshot) => {
          const progress =
            Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          setProgresspercent(progress);
        },
        (error) => {
          alert("Revisar resolución de la Cámara, resolución recomendada menor a 16 megapíxeles."+error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
           setImgUrl(downloadURL);/*visualizar imagen subida */
           agregarImagen(downloadURL,TkPicturemin); 

          /* uploadString(storageRefmin, TkPicturemin, 'data_url').then((snapshot) => {
            getDownloadURL(storageRefmin).then((urlmin) => {
              agregarImagen(downloadURL,urlmin); 
            });
          }) */
          });
        }
      );
    }
  /*Subir imagen a la BD */
  const agregarImagen = async (url, urlMin) => {
    setProgrLoading(true);

    const actividadData ={ [`List.${NoImg}.Logo.Url`]:url,[`List.${NoImg}.Logo.UrlMin`]:urlMin };

  
    const collectRef = doc(db, "Catalogos", DocID);
  
    await updateDoc(collectRef, actividadData) .then(() => {
        setUrlMin(urlMin);
        hideLoading();
      });
  
  }
    const hideLoading=()=> {
        setTimeout(() => { setProgrLoading(false); }, 2000);
       }


       const download = (e) => {
        console.log(e);
        const urlParts = decodeURIComponent(e.target.href).split("/");
        const fileId = urlParts[urlParts.length - 1].split('-')[0]; // Tomar la última parte de la URL y eliminar el token de acceso
    
        fetch(e.target.href, {
            method: "GET",
            headers: {}
        })
        .then(response => {
            response.arrayBuffer().then(function(buffer) {
                const url = window.URL.createObjectURL(new Blob([buffer]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${fileId}.jpg`); // Usa el fileId como el nombre del archivo
                document.body.appendChild(link);
                link.click();
            });
        })
        .catch(err => {
            console.log(err);
        });
    };
    
    
  return (
    <div className=''>
        <div className='Picturetaked'>
          {
            Urlmin!=""&& <>
           <img  src={Urlmin} alt="foto"  className="Imgalb"/>
        </>
  }
  <div className='RowContentMenu'>

  <label htmlFor={"inputTag"+NoImg} className='MenuTakePictureOption'>
<img src={process.env.PUBLIC_URL+"/img/picture.png"} className="uplPicture" id={"im"+NoImg}/> 
  <input type='file' className='imgselect'  accept="image/*" onChange={changeHandler} id  ={"inputTag"+NoImg} name={"inputTag"+NoImg}/> 
      </label>
      
           </div> 
            
            </div>
           
           
    
            <Dialog open={MdShowtakepicture} onClose={()=> setMdShowtakepicture(false)}>
        <DialogTitle>nueva imagen</DialogTitle>
        <DialogContent>
   
        
<div className='RowContent'>   

        <button  className='bsButton'  type="button" 
        style={(imgUrl===null||progresspercent===100)?st.hd:st.sh} onClick={handleSubmit}>Subir</button>

        </div>
     
       
        <div className='RowContent'>  

{
<div className='outerbar'>
  <div className='innerbar' style={{ width: `${progresspercent}%` }}>{progresspercent}%</div>
</div>
}
</div>
<div className='RowContent'>  
{
imgUrl &&<>
<img src={imgUrl} alt='uploaded file' className='imgupload' />
</>
}
</div> 
</DialogContent>
      </Dialog>
    </div>
  )
}
